import { httpPost, httpDownload, httpGet } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../constants/external-constants';
import {
    getCostCenter,
    setCostCenterError,
    setCostCenterColSearchStr,
    sortCostCenterItems,
    setCostCenterPageSize,
    setCostCenterFilter,
    applyCostCenterFilter,
    setDefaultCostCenter,
    getCostCenterDropdownList,
    getCostCenterbyId,
    costCenterModel,
    setCostCenterAuthorizerLoad,
    getCostCenterAuthorizers,
    setResetCostCenterAuthorize,
    setCostCenterCurrenciesLoad,
    getCostCenterCurrencies
} from "../../../constants/model-reducers/external/finance/cost-center.settings";
import { convertToFormatLocalDate } from '../../../utils/helpers.utils';
import { DEFAULT_TABLE_RESULT_COST_CENTER_DROPDOWN_MODEL } from '../../../constants/external-constants';
import { actions } from 'react-redux-form';
import { TRANSLATIONS } from '../../../utils/constant.utils';
import { convertToLocalDateToUTCDate } from '../../../utils/helpers.utils';

export const costCenterInitialState = costCenterModel

const defaultState = () => ({
    isCostCenterLoaded: false,
    isCostCenterError: false,
    costCenterItems: DEFAULT_TABLE_RESULT_MODEL,
    costCenterColSort: '',
    costCenterIsSortedAsc: true,
    costCenterTableFilterList: [],
    costCenterTableFilterApply: false,
    isCostCenterdropDownListLoaded: false,
    isFetchFormLoaded:false,
    isNew:true,
    costCenterAuthorizersLoaded: false,
    costCenterAuthorizers: [],
    hasMoreAuthorizers: false,
    costCenterCurrencyLoaded:false,
    costCenterCurrencies: [],
    hasMoreCurrencies: false,
    costCenterDetails: {
        costCenterId: 0,
        costCenter: "",
        costCenterDescription: "",
        companyCode: "",
        companyCodeDescription: "",
        authorizer: "",
        profitCenter: "",
        currency: "",
        status: "",
        validFrom: "",
        validTo: ""
    },
});
const initialState = defaultState();
export const costCenterActions = {
    setDefaultCostCenter: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultCostCenter,
            costCenterItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    getCostCenter: (pageIndex = 0, pageUnmount = false) => async (dispatch, state) => {
        const { Headers, Pagination } = state().costCenter.costCenterItems;
        const { costCenterIsSortedAsc, costCenterColSort, costCenterTableFilterList, costCenterTableFilterApply } = state().costCenter;

        var userId = sessionStorage.getItem('UserID');
         const headersToSend = pageUnmount ? {} : { ...Headers };

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: headersToSend,
                SortedColumnName: costCenterColSort,
                IsSortAscending: costCenterIsSortedAsc,
                TableFilterList: costCenterTableFilterList,
                ApplyFilter: costCenterTableFilterApply,
            };
            var costCenterItems = await httpPost('external/finance/getCostCenterItems', data);
            dispatch({
                type: getCostCenter,
                costCenterItems: Object.keys(costCenterItems).length > 0 ? costCenterItems : DEFAULT_TABLE_RESULT_MODEL,
                isCostCenterLoaded: true,
                isCostCenterError: false
            });
        }
        catch (e) {
            dispatch({
                type: setCostCenterError,
                isCostCenterError: true,
                isCostCenterLoaded: false
            });
        }
    },

    sortCostCenterItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().costCenter.costCenterItems.Pagination;
        const { costCenterItems, costCenterTableFilterList, costCenterTableFilterApply } = state().costCenter;

        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: costCenterItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...costCenterItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: costCenterTableFilterList,
            ApplyFilter: costCenterTableFilterApply,
        };
        var resCostCenterItems = await httpPost('external/finance/getCostCenterItems', data);
        if (resCostCenterItems.ok === false) {
            dispatch({
                type: setCostCenterError,
                isCostCenterError: true,
                isCostCenterLoaded: false
            });
        } else {
            dispatch({
                type: sortCostCenterItems,
                costCenterItems: Object.keys(resCostCenterItems).length > 0 ? resCostCenterItems : DEFAULT_TABLE_RESULT_MODEL,
                costCenterColSort: columnClicked,
                costCenterIsSortedAsc: isSortedAsc,
                isCostCenterLoaded: true,
            });
        }
    },

    extractCostCenter: () => async (dispatch, state) => {
        const { Headers } = state().costCenter.costCenterItems;
        const { costCenterIsSortedAsc, costCenterColSort, costCenterTableFilterList, costCenterTableFilterApply } = state().costCenter;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat } = state().adminSetting;
        var filename = `ATEM ${dealName} Cost Center Extract - ${convertToFormatLocalDate(new Date(), activeDateFormat.Name).replaceAll('/', '-')}`;
        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: costCenterColSort,
            IsSortAscending: costCenterIsSortedAsc,
            TableFilterList: costCenterTableFilterList,
            ApplyFilter: costCenterTableFilterApply,



        };
        httpDownload('external/finance/getAllCostCenterExtractItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },



    setCostCenterColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { costCenterItems } = state().costCenter;
        var costCenterItemsUpd = {
            ...costCenterItems,
            "Headers": {
                ...costCenterItems.Headers,
                [key]: {
                    ...costCenterItems.Headers[key],
                    searchString: val
                }
            }
        }
        dispatch({
            type: setCostCenterColSearchStr,
            data: costCenterItemsUpd,
            isCostCenterError: false,
            isCostCenterLoaded: true
        });
    },

    resizeCostCenterPage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setCostCenterPageSize,
            pageSize: parseInt(pageSize),
        });
    },
    addCostCenterFilter: (tableFilter) => (dispatch, state) => {
        const { costCenterTableFilterList } = state().costCenter;
        var filterList = [...costCenterTableFilterList, tableFilter];
        dispatch({
            type: setCostCenterFilter,
            filterList: filterList
        })
    },
    removeCostCenterFilter: (removeIndex) => (dispatch, state) => {
        const { costCenterTableFilterList } = state().costCenter;
        var filterList = costCenterTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });
        dispatch({
            type: setCostCenterFilter,
            filterList: filterList
        })
    },
    applyCostCenterFilter: (isApply) => (dispatch, state) => {
        const { costCenterTableFilterList } = state().costCenter;
        dispatch({
            type: applyCostCenterFilter,
            applyFilter: isApply,
            filterList: isApply ? costCenterTableFilterList : []
        });
    },
    getCostCenterDropdownList:() => async (dispatch, state) => {
        var res = await httpGet('external/finance/getCostCenterDropdownList');
        if(res != null){
            dispatch({
                type: getCostCenterDropdownList,
                isCostCenterdropDownListLoaded: true,
                costCenterDropDownList: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_COST_CENTER_DROPDOWN_MODEL,
            });
        }
        else{
            dispatch({
                type: setCostCenterError,
                isCostCenterdropDownListLoaded : false,
                isCostCenterError: true,
            });
        }
    },

    getCostCenterAuthorizersList: (page=1, searchString='') => async (dispatch, getState) => {
    
        if (getState().costCenterAuthorizersLoaded) return;

        const pageSize = 15;

        dispatch({ 
            type: setCostCenterAuthorizerLoad,
            costCenterAuthorizersLoaded: false 
        });
                
        var url = `external/finance/getCostCenterAuthorizer/${page}/${pageSize}`;

        if(searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        
        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getCostCenterAuthorizers,
                costCenterAuthorizersLoaded: true,
                costCenterAuthorizers: res?.authorizersList?.length > 0 ? res?.authorizersList : [],
                hasMoreAuthorizers: res.hasMoreData,
                page: page,
            });
        }
        else {
            dispatch({
                type: getCostCenterAuthorizers,
                costCenterAuthorizersLoaded: false,
                costCenterAuthorizers: [],
                isError: true
            });
        }
    },

    setResetCostCenterAuthorizeList: () => async(dispatch) =>{
        dispatch({
            type:setResetCostCenterAuthorize
        })
    },

    getSelectedAuthorizer: (authorizerId) => async () => {
        var res = await httpGet('external/finance/getSelectedAuthorizer' + '/' + authorizerId);
        return res;
    },

     getSelectedCurrency: (currencyId) => async () => {
        var res = await httpGet('external/finance/getSelectedCurrency' + '/' + currencyId);
        return res;
    },

    getCostCenterCurrencyList: (page=1, searchString='') => async (dispatch, getState) => {
    
        if (getState().costCenterCurrencyLoaded) return;

        const pageSize = 15;
        dispatch({ 
            type: setCostCenterCurrenciesLoad,
            costCenterCurrencyLoaded: false 
        });
                
        var url = `external/finance/getCostCenterCurrency/${page}/${pageSize}`;

        if(searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        
        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getCostCenterCurrencies,
                costCenterCurrencyLoaded: true,
                costCenterCurrencies: res?.currencyList?.length > 0 ? res?.currencyList : [],
                hasMoreCurrencies: res.hasMoreData,
                page: page,
            });
        }
        else {
            dispatch({
                type: getCostCenterCurrencies,
                costCenterCurrencyLoaded: false,
                costCenterCurrencies: [],
                isError: true
            });
        }
    },

    getCostCenterForm: (costCenterDetails) => async (dispatch, state) => {
        if (costCenterDetails) {
            var costCodeId = costCenterDetails.CostCodeId;
            var res = await httpGet(`external/finance/getCostCodeDetails/${costCodeId}`);
            var data = res.data;
        }
        const { costCenterDropDownList } = state().costCenter;
        var initialCostCenterDetail = JSON.parse(JSON.stringify(initialState.costCenterDetails));
        setCostCenterForm(dispatch, costCenterDropDownList, initialCostCenterDetail, costCenterDetails, data)
    },
    checkCostCodeDuplicate: () => {

    },

    saveCostCenterForm: (costCenterId, validate) => async (dispatch, state) =>{ 

        try{
            const { financeCostCodeForm } = state().form
            const { costCenterId, costCenter, costCenterDescription, companyCode, companyCodeDescription,
                    authorizer, profitCenter, currency, status, validFrom, validTo} = financeCostCodeForm

            const formData = {
                ...financeCostCodeForm,
                costCenterId: costCenterId,
                costCenter: costCenter,
                costCenterDescription: costCenterDescription,
                companyCode: companyCode,
                companyCodeDescription: companyCodeDescription,
                authorizer: authorizer,
                profitCenter: profitCenter,
                currency: currency,
                status: status,
                validFrom: validFrom,
                validTo: validTo
            }

            var result = await saveCostCenter(costCenterId, validate, formData);

            if (result.success && validate == false){
                dispatch(actions.load("financeCostCodeForm", financeCostCodeForm))
            }

            return result
        }
        catch (e){
            return e;
        }
    },
};

function setCostCenterForm(dispatch, costCenterDropDownList, initialCostCenterDetail, costCenterDetails, data){
    var financeCostCenterDetails = JSON.parse(JSON.stringify(initialCostCenterDetail))
    if (costCenterDetails){
        financeCostCenterDetails.costCenterId = data.CostCodeId;
        financeCostCenterDetails.costCenter = data.CostCenter;
        financeCostCenterDetails.costCenterDescription = data.CostCenterDescription;
        financeCostCenterDetails.companyCode = data.CompanyCode;
        financeCostCenterDetails.companyCodeDescription = data.CompanyCodeDescription;
        financeCostCenterDetails.authorizer = data.AuthorizerId;
        financeCostCenterDetails.profitCenter = data.ProfitCenter;
        financeCostCenterDetails.currency = data.Currency;
        financeCostCenterDetails.status = data.StatusId;
        financeCostCenterDetails.validFrom = data.ValidFrom ? new Date(data.ValidFrom) : '';
        financeCostCenterDetails.validTo = data.ValidTo ? new Date(data.ValidTo) : '';
        
    }
    dispatch(actions.reset('financeCostCodeForm'));
    dispatch(actions.load('financeCostCodeForm.costCenterId', financeCostCenterDetails.costCenterId))
    dispatch(actions.load('financeCostCodeForm.costCenter', financeCostCenterDetails.costCenter));
    dispatch(actions.load('financeCostCodeForm.costCenterDescription', financeCostCenterDetails.costCenterDescription));
    dispatch(actions.load('financeCostCodeForm.companyCode', financeCostCenterDetails.companyCode));
    dispatch(actions.load('financeCostCodeForm.companyCodeDescription', financeCostCenterDetails.companyCodeDescription));
    dispatch(actions.load('financeCostCodeForm.authorizer', financeCostCenterDetails.authorizer));
    dispatch(actions.load('financeCostCodeForm.profitCenter', financeCostCenterDetails.profitCenter));
    dispatch(actions.load('financeCostCodeForm.currency', financeCostCenterDetails.currency));
    dispatch(actions.load('financeCostCodeForm.status', financeCostCenterDetails.status));
    dispatch(actions.load('financeCostCodeForm.validFrom', financeCostCenterDetails.validFrom));
    dispatch(actions.load('financeCostCodeForm.validTo', financeCostCenterDetails.validTo));
    dispatch({
        type: getCostCenterbyId,
        financeCostCenterDetails: financeCostCenterDetails,
        isFetchFormLoaded: true,
        isCostCenterError: false,
    });
}
async function saveCostCenter(costCenterId, validate, data){
    try{
        var result = await httpPost(`external/finance/saveCostCenter/${costCenterId ?? 0}/${validate ?? 0}`, data)

        if (result.ok == false){
            throw {
                success: false,
                message: "Cost Center details is not saved. Error encouterd while on saving"
            }
        }
        return result
    }
    catch(e){
        throw e;
    }
}
export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getCostCenter:
            return {
                ...state,
                costCenterItems: action.costCenterItems,
                isCostCenterLoaded: action.isCostCenterLoaded,
                isCostCenterError: action.isCostCenterError
            };
        case setCostCenterError:
            return {
                ...state,
                isCostCenterError: action.isCostCenterError,
                isCostCenterLoaded: action.isCostCenterLoaded
            };
        case setCostCenterColSearchStr:
            return {
                ...state,
                costCenterItems: action.data,
                isCostCenterLoaded: action.isCostCenterLoaded,
                isCostCenterError: action.isCostCenterError
            };
        case sortCostCenterItems:
            return {
                ...state,
                costCenterItems: action.costCenterItems,
                costCenterColSort: action.costCenterColSort,
                costCenterIsSortedAsc: action.costCenterIsSortedAsc,
                isCostCenterLoaded: action.isCostCenterLoaded
            };
        case setCostCenterPageSize:
                return {
                    ...state,
                    costCenterItems: {
                        ...state.costCenterItems,
                        Pagination: {
                            ...state.costCenterItems.Pagination,
                            PerPage: action.pageSize
                        }
                    }
                };
        case setCostCenterFilter:
                return {
                    ...state,
                    costCenterTableFilterList: action.filterList
                };
        case applyCostCenterFilter:
            return {
                ...state,
                costCenterTableFilterApply: action.applyFilter,
                costCenterTableFilterList: action.filterList
            }
        case getCostCenterDropdownList:
            return {
                ...state,
                isCostCenterdropDownListLoaded: action.isCostCenterdropDownListLoaded,
                costCenterDropDownList: action.costCenterDropDownList,
            }
        case getCostCenterbyId:
            return{
                ...state,
                costCenterDetails: action.financeCostCenterDetails,
                financeCostCenterDetails: action.financeCostCenterDetails,
                isCostCenterError: action.isCostCenterError,
                isFetchFormLoaded: action.isFetchFormLoaded,
            }
        case setCostCenterAuthorizerLoad:
            return {
                ...state,
                costCenterAuthorizersLoaded: action.costCenterAuthorizersLoaded

        }
         case getCostCenterAuthorizers:
            return {
                ...state,
                costCenterAuthorizers: action.page === 1? action.costCenterAuthorizers ?? [] : [...state.costCenterAuthorizers, ...action.costCenterAuthorizers ?? []],
                hasMoreAuthorizers: action.hasMoreAuthorizers,
                costCenterAuthorizersLoaded: true,
                authorizerListPage: action.page
        }
        case setResetCostCenterAuthorize:
            return{
                ...state,
                costCenterAuthorizers: [],
                hasMoreAuthorizers: false,
                costCenterAuthorizersLoaded: false,
                authorizerListPage: 1
            }
        case setCostCenterCurrenciesLoad:
            return {
                ...state,
                costCenterCurrencyLoaded: action.costCenterCurrencyLoaded

        }
        case getCostCenterCurrencies:
        return {
            ...state,
            costCenterCurrencies: action.page === 1? action.costCenterCurrencies ?? [] : [...state.costCenterCurrencies, ...action.costCenterCurrencies ?? []],
            hasMoreCurrencies: action.hasMoreCurrencies,
            costCenterCurrencyLoaded: action.costCenterCurrencyLoaded,
            currenciesListPage: action.page
        }
        case setDefaultCostCenter:
            return initialState;
        default:
            return state;
    }
};